import React from 'react'
import './Products2.css';

const Products2 = () => {
  return (
    <div className='body2'>
      <div className="row">
        <div className="imgWrapper">
            <img src="/images/52.jpg" alt="" />
        </div>
        <div className="contentWrapper">
            <div className="content">
                <span className="textWrapper">
                    {/* <span>New Collection</span> */}
                </span>
                <h2>
PP Woven Fabric
</h2>
                <p>At somnath polytex, we take great pride in our exceptional PP woven fabric. It serves as the cornerstone of many of our innovative packaging solutions. Crafted with precision and engineered for strength, versatility, and durability, our PP woven fabric is the ideal foundation for a wide range of applications.</p>
                <a href="/View">VIEW MORE</a>
                {/* <a href="/Contact">Contact Us</a> */}
            </div>
        </div>
      </div>
    </div>
  )
}

export default Products2
